import { Form, Input, message, Modal } from "antd";
import { useEffect, useState } from "react";
import { postNew, updateNew } from "../../../api/news/api";
import UploadImage from "../common/UploadImage";
import TextArea from "antd/es/input/TextArea";
import CkEditorCustome from "../common/CkEditorCustom";

const AddNews = (props) => {
  const [form] = Form.useForm();
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState(props?.data?.description);

  useEffect(() => {
    if (props.data && props.isVisible) {
      form.setFieldsValue(props.data);
    } else {
      form.resetFields();
    }
  }, [form, props.data, props.isVisible]);

  const onFinish = (values) => {
    setLoading(true);
    const value = { ...values, description: content, images: images };
    if (props.data) {
      updateNew(props.data.id, value)
        .then((res) => {
          message.success("Sửa tin tức thành công");
          form.resetFields();
          props.onCancel();
        })
        .finally(() => setLoading(false));
    } else {
      postNew(value)
        .then((res) => {
          message.success("Thêm tin tức thành công");
          form.resetFields();
          props.onCancel();
        })
        .finally(() => setLoading(false));
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
 

  const handleChange = (event, editor) => {
    const data = editor.getData();
    setContent(data);
  };

  return (
    <Modal
      title={props.data ? "Sửa tin tức" : "Thêm mới tin tức"}
      centered
      open={props.isVisible}
      onOk={() => form.submit()}
      onCancel={props.onCancel}
      width={1000}
      destroyOnClose={true}
      okButtonProps={{
        className: "bg-admin-btn-primary",
      }}
      okText={props.data ? "Cập nhật" : "Tạo mới"}
      confirmLoading={loading}
    >
      <Form
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="vertical"
      >
        <Form.Item
          label="Tin tức"
          name="name"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập tin tức!",
            },
          ]}
        >
          <Input placeholder={"Nhập tin tức"} />
        </Form.Item>
        <Form.Item
          label="Nha khoa"
          name="supplier"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập nha khoa!",
            },
          ]}
        >
          <Input placeholder={"Nhập nha khoa"} />
        </Form.Item>
        <Form.Item
          label="Mô tả ngắn"
          name="type"
          rules={[
            {
              required: false,
            },
          ]}
        >
          <TextArea
            showCount
            placeholder="Nhập thông tin mô tả"
            style={{
              height: 120,
              resize: "none",
            }}
          />
        </Form.Item>
        <Form.Item
          label="Nội dung tin tức"
          rules={[
            {
              required: false,
            },
          ]}
        >
          <CkEditorCustome
            label={"Nội dung tin tức"}
            description={props?.data?.description}
            setContent={handleChange}
          />
        </Form.Item>
        <UploadImage url={(e) => setImages(e)} />
      </Form>
    </Modal>
  );
};
export default AddNews;
